import { fork } from 'redux-saga/effects';
import Swal from 'sweetalert2';

import watchTATSaga from "../TAT/services/TATSaga";
import watchUnreadSaga from '../Unread/services/UnreadSaga';
import watchRawExamSaga from '../rawExamData/services/RawExamSaga';
import watchMiscellaneousSaga from '../miscellaneousSiteData/services/miscellaneousSaga';
import watchReadSaga from '../read/services/ReadSaga';
import watchExamDataSaga from '../examData/services/examDataSaga';
import watchRawExamDataSaga from '../rawExamData/services/rawExamDataSaga';
import watchExamMetricsSaga from '../examMetrics/services/examMetricsSaga';

// Watcher Saga
export default function* examSaga() {
    yield fork(watchTATSaga);
    yield fork(watchUnreadSaga);
    yield fork(watchRawExamSaga);   
    yield fork(watchMiscellaneousSaga); 
    yield fork(watchReadSaga);
    yield fork(watchExamDataSaga);
    yield fork(watchRawExamDataSaga);
    yield fork(watchExamMetricsSaga);
}
